<mat-form-field appearance="outline" class=" mx-4">
  <mat-label>Select Centre</mat-label>
  <mat-select  [(ngModel)]="selectedCentre" (selectionChange)="search()">
    <mat-option *ngFor=" let c of (centres$|async) "
                [value]="c.centreCode">{{c.centreName}} </mat-option>
    <!--      <mat-option  value="All">All Centres</mat-option>-->
  </mat-select>
</mat-form-field>

<mat-form-field appearance="outline" class=" mx-4">
  <mat-label>Select Child</mat-label>
  <mat-select  [(ngModel)]="selectedChildCode" (selectionChange)="searchChild()">
    <mat-option *ngFor=" let c of (childBycentre|async)  "
                [value]="c">{{c.firstName}} {{c.lastName}} </mat-option>
    <!--      <mat-option  value="All">All Centres</mat-option>-->
  </mat-select>
</mat-form-field>

<h1 ></h1>

<table class="table table-bordered" >
  <tr>
    <th>Follow Up Date</th>
  </tr>

  <tr *ngFor="let data of ChildData">
    <td>{{data.followUpDate.toDate() |date:"dd/MM/yyyy" }}</td>
  </tr>
</table>
